export default "__VITE_ASSET__ALDnzhds__"